import { PlanType, ShiftType } from "../../types/shiftPlan";

/**
 * Convert display-friendly shift option value to API ShiftType
 */
export function getClockWindowNameBasedOnSelectedOption(selectedOption: string): ShiftType {
  if (selectedOption === "night") {
    return "NIGHT";
  }
  return "DAY";
}

/**
 * Convert tab selection value to API PlanType
 */
export function getPlanTypeBasedOnSelectedTab(selectedTab: string): PlanType {
  if (selectedTab === "sos") {
    return "PRE_SHIFT";
  } else if (selectedTab === "pdp") {
    return "NEXT_DAY";
  }
  return "PRE_SHIFT";
}

/**
 * Convert display-friendly half option value to API half value
 */
export function getHalfNameBasedOnSelectedOption(selectedOption: string): string {
  if (selectedOption === "second") {
    return "SECOND_HALF";
  }
  return "FIRST_HALF";
}
